var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbsFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000048458980465009334690000003905229327016955823_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.8,
    cy: 25.3,
    r: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4,8l2.1,2c0,0-7.1,5.7-6.1,17.2c0,0-0.1,6.4,6.1,12.9L7.6,42c0,0-6.7-6.2-7.2-15C0.4,26.9-1.2,17.2,7.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1,8.3l-2.2,2c0,0,7.3,5.7,6.3,17.2c0,0,0.1,6.4-6.3,12.9l1.9,1.9c0,0,6.9-6.2,7.3-15C47.2,27.2,48.9,17.5,40.1,8.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 23.8,
    cy: 25,
    rx: 15.6,
    ry: 16.1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4,27.8l-0.7,2.7h-2.4l3.2-10.4h3.1l3.2,10.4h-2.5l-0.8-2.7H13.4z M16.1,26l-0.6-2.2c-0.2-0.6-0.4-1.4-0.5-2h0 c-0.2,0.6-0.3,1.4-0.5,2L13.8,26H16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1,20.2c0.6-0.1,1.9-0.2,3-0.2c1.4,0,2.3,0.1,3.1,0.6c0.7,0.4,1.2,1.1,1.2,2c0,0.9-0.5,1.8-1.7,2.2v0 c1.2,0.3,2.1,1.2,2.1,2.6c0,0.9-0.4,1.7-1.1,2.2c-0.8,0.6-2,0.9-4.1,0.9c-1.2,0-2-0.1-2.5-0.2V20.2z M23.4,24.2h0.8 c1.2,0,1.9-0.5,1.9-1.3c0-0.8-0.6-1.2-1.7-1.2c-0.5,0-0.8,0-1,0.1V24.2z M23.4,28.8c0.2,0,0.5,0,0.9,0c1.1,0,2-0.4,2-1.5 c0-1-0.9-1.5-2.1-1.5h-0.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,28c0.6,0.3,1.6,0.6,2.6,0.6c1.1,0,1.6-0.4,1.6-1.1c0-0.6-0.5-1-1.7-1.5c-1.7-0.6-2.8-1.6-2.8-3.1 c0-1.8,1.5-3.1,3.9-3.1c1.2,0,2,0.2,2.6,0.5l-0.5,1.9c-0.4-0.2-1.2-0.5-2.2-0.5c-1,0-1.5,0.5-1.5,1c0,0.7,0.6,1,1.9,1.5 c1.8,0.7,2.7,1.6,2.7,3.1c0,1.7-1.3,3.2-4.2,3.2c-1.2,0-2.4-0.3-2.9-0.6L30.5,28z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "8.5,4.8 10.7,3.4 39,45.1 37.1,46.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsFailure);
export default __webpack_public_path__ + "static/media/ABSFailure.4efdde0d5047d6b5206bac41b0c42d22.svg";
export { ForwardRef as ReactComponent };